import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { useCustomTranslation } from "../../../helpers/translateHelpers";
import { useValidators } from "../../../helpers/validation";
import TextInput from "../TextInput";
import { GeoCoordinate } from "../../../common/models";
import SubmitButton from "../SubmitButton";
import AddressAutocompleteInput from "./AddressAutocompleteInput";
import { useState } from "react";
import { SelectItem } from "../../select/Select";

interface AddressFormProps {
  onSubmit: (data: AddressFormValues) => void;
}

export interface AddressFormValues {
  street: SelectItem;
  city: string;
  postalCode: string;
  country?: string | null;
  coordinates?: GeoCoordinate;
}

const AddressForm = (props: AddressFormProps) => {
  const { tInput } = useCustomTranslation();

  const [showAllFields, setShowAllFields] = useState(false);

  const methods = useForm<AddressFormValues>({
    mode: "onBlur",
  });

  const validators = useValidators();

  const onSubmit: SubmitHandler<AddressFormValues> = (data) => {
    props.onSubmit(data);
  };

  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        {!showAllFields ? (
          <AddressAutocompleteInput
            name="fakeStreet"
            required
            options={{
              required: validators.required,
              maxLength: validators.maxLength(100),
            }}
            placeholder={tInput("address_placeholder")}
            setShowAllFields={() => setShowAllFields(true)}
            disableCreate
          />
        ) : (
          <div className="grid grid-cols-2 gap-x-2">
            <AddressAutocompleteInput
              name="street"
              required
              options={{
                required: validators.required,
                maxLength: validators.maxLength(100),
              }}
              placeholder={tInput("address_street_placeholder")}
            />
            <TextInput
              name="city"
              required
              options={{
                required: validators.required,
                maxLength: validators.maxLength(50),
              }}
              placeholder={tInput("address_city_placeholder")}
            />
            <TextInput
              name="postalCode"
              required
              options={{
                required: validators.required,
                maxLength: validators.maxLength(10),
              }}
              placeholder={tInput("address_postal_code_placeholder")}
            />
            <TextInput
              name="country"
              required
              options={{
                required: validators.required,
                maxLength: validators.maxLength(50),
              }}
              placeholder={tInput("address_country_placeholder")}
            />
          </div>
        )}

        <SubmitButton className="mt-2" label={tInput("address_add_button")} />
      </form>
    </FormProvider>
  );
};

export default AddressForm;
